export default function IconArrow() {
    return (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" className="comp-item-icon">
            <path d="M18.5 14.5L12.5 8.5L6.5 14.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}